import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, withCtx as _withCtx, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "flex items-center gap-2 text-white" }
const _hoisted_2 = { class: "uppercase text-xxs" }
const _hoisted_3 = { class: "max-w-[300px] w-full" }
const _hoisted_4 = { class: "w-full" }
const _hoisted_5 = { class: "w-full text-center nk-popper-item" }
const _hoisted_6 = { class: "nk-popper-item" }

import { clearAuthTokens } from 'axios-jwt';
import { computed, ComputedRef, onMounted, Ref, ref } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import {useDebounceFn} from '@vueuse/core';

import { useGetCurrentUserQuery } from '@/entities/user/hooks';
import { ADMIN_GRANTS } from '@/entities/app/consts';

import {
  NkSelect,
  NkOption,
  NkGroup,
  NkIcon,
  NkPopper,
  NkButton,
  NkStack,
	NkSearchBar
} from '@/core/components';

import { searchDeviceGroups } from '@/entities/device-group/services';
import DashboardNavigationInspectionBreadcrumb
  from '@/entities/app/components/navigation/DashboardNavigationInspectionBreadcrumb.vue';
import { useStore } from 'vuex';

import { StNavigation } from './navigation.styled';
import { RouteEntry } from './navigation.types';


export default /*#__PURE__*/_defineComponent({
  __name: 'DashboardNavigation',
  setup(__props) {

const router = useRouter();
const route = useRoute();
const store = useStore();

const computedBanner = computed(() => process.env.VUE_APP_BANNER);

const { data: user } = useGetCurrentUserQuery();

const searchData = ref([]);
const isSearching = ref(false);

const entries: ComputedRef<RouteEntry[]> = computed(() => ([
  {
    name: 'Visionair',
    path: {
      name: 'visionair-dashboard',
    },
    slug: 'visionair',
    icon: 'NkVisionair',
  },
  {
    name: 'Administration',
    path: {
      name: 'admin-organizations',
    },
    slug: 'admin',
    icon: 'NkVisionair',
    roles: ADMIN_GRANTS,
  },
]));
const filteredEntries = computed(() => entries.value.filter(o => !o?.roles || o.roles?.some(r => o.roles?.includes(r))));

const activeEntry: Ref<RouteEntry> = ref(filteredEntries.value[0]);
const getActiveEntry: ComputedRef<RouteEntry | undefined> = computed(() => filteredEntries.value.find(o => o.slug === route.meta?.entry) || filteredEntries.value[0]);

const handleEntryChange = (entry: RouteEntry) => {
  activeEntry.value = entry;
  router.push(entry.path);
};

const goToProfile = () => router.push({ name: 'visionair-profile' });
const goToResource = () => router.push({ name: 'visionair-resource' });

const logout = () => {
  clearAuthTokens();
  router.go(0);
};

const search = useDebounceFn(async (name) => {
	isSearching.value = true;
	const results = await searchDeviceGroups(name);
	isSearching.value = false;

	searchData.value = results.map((result) => ({
		label: result._highlightResult.name.value,
		id: result.objectID,
		route: {
			name: 'visionair-device-group',
			params: {
				deviceGroup: result.objectID,
			},
		}
	}));
}, 300);

onMounted(() => {
  if (getActiveEntry.value) {
    activeEntry.value = (getActiveEntry.value as RouteEntry);
  }
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(StNavigation), null, {
    default: _withCtx(() => [
      _createVNode(_unref(NkGroup), {
        position: "apart",
        "no-wrap": ""
      }, {
        default: _withCtx(() => [
          _createVNode(_unref(NkGroup), {
            spacing: 6,
            class: "w-full",
            "no-wrap": ""
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkSelect), {
                theme: "primary",
                "value-key": "slug",
                "model-value": activeEntry.value,
                "onUpdate:modelValue": handleEntryChange
              }, {
                inside: _withCtx(() => [
                  _createElementVNode("div", _hoisted_1, [
                    _createVNode(_unref(NkIcon), {
                      name: _unref(getActiveEntry)?.icon,
                      size: 5
                    }, null, 8, ["name"]),
                    _createElementVNode("p", _hoisted_2, _toDisplayString(_unref(getActiveEntry).name), 1)
                  ])
                ]),
                default: _withCtx(() => [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(filteredEntries), (entry) => {
                    return (_openBlock(), _createBlock(_unref(NkOption), {
                      key: entry.slug,
                      label: entry.name,
                      value: entry
                    }, null, 8, ["label", "value"]))
                  }), 128))
                ]),
                _: 1
              }, 8, ["model-value"]),
              _createElementVNode("div", _hoisted_3, [
                _createVNode(_unref(NkSearchBar), {
                  onChange: _unref(search),
                  loading: isSearching.value,
                  data: searchData.value
                }, null, 8, ["onChange", "loading", "data"])
              ]),
              _createElementVNode("div", _hoisted_4, [
                (_unref(getActiveEntry).slug === 'visionair')
                  ? (_openBlock(), _createBlock(DashboardNavigationInspectionBreadcrumb, { key: 0 }))
                  : _createCommentVNode("", true)
              ])
            ]),
            _: 1
          }),
          _createVNode(_unref(NkGroup), {
            spacing: 6,
            class: "text-black"
          }, {
            default: _withCtx(() => [
              _createVNode(_unref(NkPopper), { styled: "" }, {
                reference: _withCtx(() => [
                  _createVNode(_unref(NkIcon), {
                    class: "cursor-pointer",
                    size: 6,
                    name: "NkProfile"
                  })
                ]),
                default: _withCtx(() => [
                  _createVNode(_unref(NkStack), {
                    class: "nk-popper-item-wrapper",
                    spacing: 1,
                    align: "strech"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(user)?.email), 1),
                      _createElementVNode("div", _hoisted_6, [
                        _createVNode(_unref(NkStack), { spacing: 2 }, {
                          default: _withCtx(() => [
                            _createVNode(_unref(NkButton), {
                              icon: "NkProfile",
                              onClick: goToProfile
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('profile.profile')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NkButton), {
                              icon: "NkAssignment",
                              onClick: goToResource
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('Resource')), 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_unref(NkButton), {
                              type: "danger",
                              icon: "NkLogin",
                              onClick: logout
                            }, {
                              default: _withCtx(() => [
                                _createTextVNode(_toDisplayString(_ctx.$t('profile.logout')), 1)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ])
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})